import { useEffect, useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { AuthLayout } from "../components/AuthLayout";
import { EmailAuthForm } from "../components/EmailAuthForm";
import { FullPageLoader } from "../components/RouteGuards";
import { useAuth } from "../context/AuthContext";
import { isStaffRole } from "../lib/authApi";
import { supabase } from "../lib/supabase";
import Wizard from "../components/register/Wizard";
import { UnderReview } from "../components/register/UnderReview";

function RegistrationFlow({ userId }) {
  const [profile, setProfile] = useState(undefined);
  useEffect(() => {
    supabase.from("profiles").select("id,registration_no,status,full_name").eq("user_id", userId).maybeSingle()
      .then(({ data }) => setProfile(data || null));
  }, [userId]);
  if (profile === undefined) return <FullPageLoader />;
  if (profile) return <UnderReview profile={profile} />;
  return <Wizard onSubmitted={setProfile} />;
}

export default function Register() {
  const { session, role, loading } = useAuth();
  if (loading) return <FullPageLoader />;
  if (!session) {
    return (
      <AuthLayout testId="register-account-page" eyebrow="Begin your journey" title="Create your account" subtitle="Create an account first, then complete your registration form. You can save a draft and continue any time.">
        <EmailAuthForm
          mode="register"
          footer={<>Already registered? <Link to="/login" data-testid="go-to-login-link" className="font-semibold text-[#7A0016] hover:underline">Sign in</Link></>}
        />
      </AuthLayout>
    );
  }
  if (isStaffRole(role)) return <Navigate to="/admin" replace />;
  return <RegistrationFlow userId={session.user.id} />;
}
